<div *ngIf="carregando" class="overlay">
  <img src="assets/img/loading3.gif" class="imagem">
</div>
<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{"Alterar Agência" | translate}}</h4>
  <button type="button" class="close" [disabled]="carregando" aria-label="Close" (click)="fecharModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">


      <div class="card-sem_borda strpied-tabled-with-hover">
        <div class="card-header ">
          <h4 class="card-title fonte-Cabecalho_form">{{'Agências' | translate }}</h4>
          <div class="row">
            <div *ngIf="mensagemSuccesso != ''" class="alert alert-success alert-dismissible fade show col-sm-12 col-md-12" role="alert">
              <strong> {{ mensagemSuccesso | translate}} </strong>
              <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="mensagemSuccesso = ''">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div *ngIf="mensagemErro != ''" class="alert alert-danger alert-dismissible fade show col-sm-12 col-md-12" role="alert">
              <strong>{{ mensagemErro | translate}}</strong>
              <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="mensagemErro = ''">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>

          <div class="row fonte-Corpo_form">

            <div class="col-sm-12 col-md-3">
              <input nbInput type="number" fullWidth fieldSize="medium" shape="rectangle" placeholder="ID" autocomplete="off"
              name="buscarporid" [(ngModel)]="parametroId" (input)="buscarDebounce()"/>
            </div>

            <div class="col-sm-12 col-md-8">
              <input nbInput fullWidth fieldSize="medium" shape="rectangle" [placeholder]="'Buscar' | translate" autocomplete="off"
              name="buscar" [(ngModel)]="parametroBusca" [disabled]="(parametroId != null && parametroId != '') ? true : false"  (input)="buscarDebounce()"/>
            </div>

            <div class="col-sm-12 col-md-1">
              <button [disabled]="parametroBusca.length == 0" (click)="buscarPorParametro()" class="btn-block botao-busca" nbButton status="primary" size="small" [title]="'Buscar' | translate"  outline ghost><i class="fa fa-search"></i></button>
            </div>
          </div>
        </div>

        <div class="card-body table-full-width table-responsive">
          <table class="table table-hover table-striped">
            <thead>
              <th>ID</th>
              <th></th>
              <th>{{'Razão Social' | translate }}</th>
              <th>{{"Nome Fantasia" | translate}}</th>
              <th>{{'CNPJ' | translate }}</th>
              <th>{{"Selecionar" | translate}}</th>
            </thead>
            <tbody>
              <tr *ngFor="let dado of dados">
                <td>{{dado.Id}}</td>
                <td [ngSwitch]="dado.Situacao">
                  <span *ngSwitchCase="1" class="badge badge-pill badge-danger">{{"Bloqueada" | translate}}</span>
                  <span *ngSwitchCase="2" class="badge badge-pill badge-danger">{{'Pendente' | translate}}</span>
                  <span *ngSwitchCase="3" class="badge badge-pill badge-danger">{{"Reprovada" | translate}}</span>
                </td>
                <td>{{dado.RazaoSocial}}</td>
                <td>{{dado.NomeFantasia}}</td>
                <td>{{dado.CNPJ}}</td>
                <td>
                  <button (click)="selecionar(dado)" type="button" class="btn btn-xs btn-success botao-selecionar" style="margin-left:5px">
                    {{"Selecionar" | translate}}
                  </button>


                </td>
              </tr>
            </tbody>
          </table>
          <hr>

        <paginacao [paginacao]="paginacao" (alterarPagina)="buscarPagina($event)" ></paginacao>

        </div>
      </div>




</div>
<div class="modal-footer" style="display:block">
  <!-- <div class="row">
    <div>
      <button (click)="fecharModal()" [disabled]="carregando" class="btn btn-warning" type="submit">{{'Fechar' | translate}}</button>
    </div>
  </div> -->
</div>
